<div *ngIf="(pageVm$ | async) as pageVm">

    <app-page-header [vm]="pageVm" title='Vehicle Request' [fullHeader]="true" [canAddNew]="true">
    </app-page-header>    

    <div *ngIf="pageVm.contentVm as vm">

        <!-- affiliate response -->
        <div *ngIf="vm.vehicleRequestResponseVm as otvm" class="text-center">
            <div>
                {{otvm.workflowItemStatus}}
            </div>

            <div *ngIf="otvm.data as vrd">
                <div class="text-center">
                    '{{vrd.vehicleTypeCode}}' on '{{vrd.pickupDate}}' at '{{vrd.pickupTime}}'
                </div>
                <div  class="text-center">
                    From '{{vrd.pickupLocation}}' to '{{vrd.dropLocation}}'
                </div>                
            </div>
        </div>

        <!-- forms -->
        <div *ngIf="vm.formVm as fvm" class="mt-3">

            <!-- loading / error -->
            <div *ngIf="fvm.loadingError || (!fvm.loadingErrorText && fvm.loading)">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div *ngIf="fvm.loadingError" class="text-danger text-center">
                            <div>{{fvm.loadingErrorText}}</div>
                            <div>
                                <a class="underlined" href="javascript:null" (click)="formEnd(pageVm)">Back</a>
                            </div>
                        </div>
                        <div *ngIf="!fvm.loadingErrorText && fvm.loading">Loading...</div>
                    </div>
                </div>
            </div>

            <!-- nog loading / no error -->
            <div *ngIf="!fvm.loading && !fvm.loadingError">

                <!-- vehicle request -->
                <div class="row" *ngIf="fvm.type == 'vehicle-request'">
                    <div class="col-md-12">
                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="5" [title]="'New Request'">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">

                                <div class="row">
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.resNumberInputVm"></app-form-input>
                                    </div>
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.pickupDateInputVm"
                                                    (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-4">
                                        <app-form-input [vm]="fvm.pickupTimeInputVm"
                                                    (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <app-form-auto-complete [vm]="fvm.serviceAreaAutoCompleteVm"></app-form-auto-complete>
                                    </div>
                                    <div class="col-md-6">
                                        <app-form-auto-complete [vm]="fvm.vehicleTypeAutoCompleteVm"
                                            (selected)="requestFormValidate(vm, fvm)"></app-form-auto-complete>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-md-6">
                                        <app-form-auto-complete [vm]="fvm.customerCodeAutoCompleteVm"
                                            (selected)="requestFormValidate(vm, fvm)"></app-form-auto-complete>
                                    </div>
                                    <div class="col-md-6">
                                        <app-form-auto-complete [vm]="fvm.passengerCodeAutoCompleteVm"
                                            (selected)="requestFormValidate(vm, fvm)"></app-form-auto-complete>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <app-form-input [vm]="fvm.pickupLocationInputVm"
                                            (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-6">
                                        <app-form-input [vm]="fvm.dropLocationInputVm"
                                            (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <app-form-input [vm]="fvm.bookerNameInputVm"
                                            (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                    <div class="col-md-6">
                                        <app-form-input [vm]="fvm.bookerPhoneInputVm"
                                            (textChanged)="requestFormValidate(vm, fvm)"></app-form-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <app-form-input [vm]="fvm.commentsInputVm"></app-form-input>
                                    </div>
                                </div>

                            </mdb-card-body>
                        </mdb-card>
                        <app-form-ok-cancel *ngIf="fvm.okCancelVm" [vm]="fvm.okCancelVm" [isInvalid]="!fvm.isValid"
                            (cancelClicked)="formEnd(pageVm)" (okClicked)="requestFormOk(pageVm, vm, fvm)">
                        </app-form-ok-cancel>
                    </div>
                </div>

                <!-- workflow / complete -->
                <div class="row" *ngIf="fvm.type == 'workflow-complete'">
                    <div class="col-md-12">
                        <app-form-comment [formTitle]="fvm.title" [required]="true"
                            (accepted)="workflowCompleteFormOk(pageVm, fvm, $event)" 
                            (cancelled)="formEndRefresh(pageVm)"></app-form-comment>
                    </div>
                </div>

            </div>

        </div>

        <!-- main content -->
        <div *ngIf="!vm.formVm" class="mt-3">
            
            <!-- tabs -->
            <div class="row" *ngIf="vm.tabVms">
                <div class="col-md-12 pb-3">
                    <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">
                        <mdb-tab *ngFor="let tvm of vm.tabVms" [heading]="tvm.title">
                            <app-data-table-card [vm]="tvm.dataPanelVm" [showHeader]="false"
                                (rowActionClick)="rowActionInvoke(pageVm, tvm, $event)">
                            </app-data-table-card>
                        </mdb-tab>
                    </mdb-tabset>                                        
                </div>
            </div>

        </div>
    </div>

</div>